import { runJsonGet, runJsonPost } from '@/backend-client'
import { OPERATIONS_BACKEND_URL } from '@/config'
import { MarketplaceResponse } from './models/marketplace-service-model'
import { transformKeysToCamelCase, transformKeysToSnakeCase } from './utils/casing'

export const fetchOrders: (param: any) => Promise<MarketplaceResponse> = async params => {
  const { data } = await runJsonGet(
    `${OPERATIONS_BACKEND_URL}/marketplace/orders`,
    transformKeysToSnakeCase(params)
  )
  return transformKeysToCamelCase(data)
}

export const sendTransportRequest = async payload => {
  const { data } = await runJsonPost(
    `${OPERATIONS_BACKEND_URL}/orders-matching/transport_requests/`,
    payload
  )
  return transformKeysToCamelCase(data)
}

export const acceptOrderNow = async payload => {
  const { data } = await runJsonPost(
    `${OPERATIONS_BACKEND_URL}/orders-matching-transport-requests/commands/carrier/transport-requests/accept-now`,
    payload
  )

  return transformKeysToCamelCase(data)
}

export const fetchMarketplaceLocations = async pattern => {
  const response = await runJsonGet(
    `${OPERATIONS_BACKEND_URL}/filtering/queries/locations-autocomplete`,
    transformKeysToSnakeCase(pattern)
  )
  return transformKeysToCamelCase(response.data)
}
